import React from 'react'
import { Input } from 'antd'

import { InputProps } from 'antd/lib/input'

/** Декоратор для `Input.Password` от `antd` */
export const InputPasswordControl: React.FC<InputProps> = React.memo(props => {
    return <Input.Password {...props} />
})
